__turbopack_context__.v({
  "blockSpacing": "RichText-module-scss-module__atbHLq__blockSpacing",
  "bulletList": "RichText-module-scss-module__atbHLq__bulletList",
  "h2": "RichText-module-scss-module__atbHLq__h2" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "h3": "RichText-module-scss-module__atbHLq__h3" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "h4": "RichText-module-scss-module__atbHLq__h4" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "hihImage": "RichText-module-scss-module__atbHLq__hihImage" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "hihImageImage": "RichText-module-scss-module__atbHLq__hihImageImage",
  "hihQuote": "RichText-module-scss-module__atbHLq__hihQuote" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "instagramPost": "RichText-module-scss-module__atbHLq__instagramPost" + " " + "RichText-module-scss-module__atbHLq__blockSpacing",
  "link": "RichText-module-scss-module__atbHLq__link",
  "numberList": "RichText-module-scss-module__atbHLq__numberList",
  "paragraph": "RichText-module-scss-module__atbHLq__paragraph",
  "richText": "RichText-module-scss-module__atbHLq__richText",
});
